export default __webpack_public_path__ + "static/media/pig.844fb0f6.png";